<template>
<body>

  <div id="colorlib-page">
    <NavBar />
    <div id="colorlib-main">
      <section class="ftco-section ftco-no-pt ftco-no-pb bg-light">
        <div class="container px-0">
          <div class="row no-gutters">

            <div class="col-md-4 d-flex" v-for="post in posts" :key="post.id" :post="post">
              <div class="blog-entry ftco-animate">
                <a :href="post.slug" class="img" v-bind:style="'background-image: url('+post.feature_image+');'"></a>
                <div class="text p-4">
                  <h3 class="mb-2"><a :href="post.slug"> {{ post.title }} </a></h3>
                  <div class="meta-wrap">
                    <p class="meta">
                      <span><i class="icon-calendar mr-2"></i> {{ post.updated_at | formatDate }} </span>
                      <span><a :href="post.slug"><i class="icon-folder-o mr-2"></i>Travel</a></span>
                      <span><i class="icon-comment2 mr-2"></i> {{ post.authors[0].name }} </span>
                    </p>
                  </div>
                  <p class="mb-4"> {{ post.excerpt | truncate(200, '...')}} </p>
                  <p><a :href="post.slug" class="btn-custom">Read More <span class="ion-ios-arrow-forward"></span></a></p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div><!-- END COLORLIB-MAIN -->
  </div><!-- END COLORLIB-PAGE -->

  <!-- loader -->
  <div id="ftco-loader" class="show fullscreen"><svg class="circular" width="48px" height="48px">
      <circle class="path-bg" cx="24" cy="24" r="22" fill="none" stroke-width="4" stroke="#eeeeee" />
      <circle class="path" cx="24" cy="24" r="22" fill="none" stroke-width="4" stroke-miterlimit="10" stroke="#F96D00" />
    </svg></div>
</body>
</template>

<script>
import {
  getPosts,
  getPostbyAuthor
} from '@/api/posts'
import NavBar from '@/components/NavBar'

export default {
  name: 'Home',
  components: {
    NavBar
  },
  props: ['post'],
  data: () => ({
    posts: []
  }),
  mounted() {
    this.asyncData()
  },
  methods: {
    async asyncData() {
      getPostbyAuthor('khunkhaaw').then(result => {
        this.posts = result
      })
    }
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text !== null) {
        return text.substring(0, length) + suffix
      }
    },
    formatDate: function (date) {
      return date.replace('T', ', ').replace('.000', '').replace('+07:00', '')
    }
  }
}
</script>

<style>

</style>
